import PremiumLanding from './PremiumLanding';

export default function App() {
  return <PremiumLanding />;
}